import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan as trash, faLocationDot as loc } from '@fortawesome/free-solid-svg-icons';
import { favoritesDelExhibitor, favoritesShow } from '../../store/favoritesSlice';
import getLogo from '../../utils/getLogo';

const FavoritesExhibitors = ({ exhibitors }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Переход на страницу экспонента
    const onClick = (item) => {
        dispatch(favoritesShow(false));
        // Нам надо учесть что мы можем быть в режиме виджета
        if(location.pathname.startsWith('/catalog/')) {
            navigate('/catalog/exhibitor/' + item._id);
        } else {
            navigate('/widget/exhibitor/' + item._id);
        }
    };

    // Удаление из избранного
    const onRemove = (e, item) => {
        e.stopPropagation();
        dispatch(favoritesDelExhibitor(item));
    };

    if(!exhibitors || !exhibitors.length) return t('favorites.noexhibitors');

	return (
        <div className='list'>
        {exhibitors.map(item => (
            <div
                key={item._id}
                className='item'
                onClick={() => onClick(item)}
            >
                <img alt='icon' src={getLogo(item)}/>
                <div className='text'>
                    {item.name[lang]}
                    {item.stand &&
                    <div className='small'>
                        <FontAwesomeIcon icon={loc}/> {item.stand}
                    </div>}
                    <div className='small'>{item.brief[lang]}</div>
                    {item.stickers?.length > 0 &&
                    <ul>
                        {item.stickers.map((sticker, index) => (
                            <li
                                key={index}
                                style={{
                                    color: sticker.color,
                                    backgroundColor: sticker.background,
                                }}
                            >
                                {sticker.text[lang]}
                            </li>
                        ))}
                    </ul>}
                </div>
                <FontAwesomeIcon
                    className='remove'
                    icon={trash}
                    onClick={e => onRemove(e, item)}
                />
            </div>
        ))}
    </div>
	);
};

export default FavoritesExhibitors;
